import { render, staticRenderFns } from "./TwilioChatPreview.vue?vue&type=template&id=ca1ad7ec&scoped=true"
import script from "./TwilioChatPreview.vue?vue&type=script&lang=js"
export * from "./TwilioChatPreview.vue?vue&type=script&lang=js"
import style0 from "./TwilioChatPreview.vue?vue&type=style&index=0&id=ca1ad7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1ad7ec",
  null
  
)

export default component.exports